// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teamSummary {
  display: flex;
  flex-direction: column;
}
.teamSummary__row {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 11px 0;
  border-bottom: 1px solid #e5eaf0;
}
.teamSummary__row:last-child {
  border-bottom: 0;
}
.teamSummary__row span {
  color: #69778a;
  font-size: 11px;
  font-weight: 650;
  letter-spacing: 0.03em;
  line-height: 1.35;
  text-transform: uppercase;
}
.teamSummary__row strong {
  color: #142033;
  font-size: 14px;
  font-weight: 550;
  line-height: 1.45;
}
`, "",{"version":3,"sources":["webpack://./src/components/SchoolTeamSummary/SchoolTeamSummary.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".teamSummary {\n  display: flex;\n  flex-direction: column;\n}\n.teamSummary__row {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  padding: 11px 0;\n  border-bottom: 1px solid #e5eaf0;\n}\n.teamSummary__row:last-child {\n  border-bottom: 0;\n}\n.teamSummary__row span {\n  color: #69778a;\n  font-size: 11px;\n  font-weight: 650;\n  letter-spacing: 0.03em;\n  line-height: 1.35;\n  text-transform: uppercase;\n}\n.teamSummary__row strong {\n  color: #142033;\n  font-size: 14px;\n  font-weight: 550;\n  line-height: 1.45;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
